import { useQuery } from '@tanstack/react-query'
import type { AtisStation, AtisStationBroadcast } from '@jupi/shared'
import { api } from '@jupi/ui'

export const atisKeys = {
  stations: ['atis', 'stations'] as const,
  station: (icao: string) => ['atis', 'station', icao] as const,
}

export function useAtisStations() {
  return useQuery({
    queryKey: atisKeys.stations,
    queryFn: () => api.get<{ stations: AtisStation[] }>('/api/atis/stations').then((r) => r.stations),
    staleTime: 60 * 60_000,
  })
}

export function useAtisBroadcast(icao: string) {
  return useQuery({
    queryKey: atisKeys.station(icao),
    queryFn: () => api.get<AtisStationBroadcast>(`/api/atis/stations/${encodeURIComponent(icao)}`),
    // Matches the API's refresh interval; faster returns the same data.
    refetchInterval: 2 * 60_000,
    staleTime: 60_000,
  })
}
